<div *ngIf="!isLoading; else spinner">
  <h1 mat-dialog-title xmlns="http://www.w3.org/1999/html">
    <ng-container >Edit Operations</ng-container>
  </h1>
  <mat-dialog-content [formGroup]="formGroup">
    <div class="form-container">
      <fieldset class="fieldset-container">
        <legend>Operations</legend>
        <p>
          <mat-form-field class="edit-operations">
            <input matInput
                   placeholder="App/Depart Control Facility"
                   formControlName="masterAirportTower"
                   [(ngModel)]="airport.masterAirportTower">
          </mat-form-field>
          <mat-form-field class="edit-operations">
            <mat-select [id]="fssSelectId" formControlName="fssName" placeholder="Select Fss Name"
                        (selectionChange)="fssNameChange($event)">
              <mat-option value="">None</mat-option>
              <mat-option *ngFor="let fss of fsses" value="{{fss.name}}">
                {{fss.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="edit-operations">
            <input #fssPhone
                   matInput
                   placeholder="FSS Phone"
                   formControlName="fssPhone"
                   maxlength="14"
                   (blur)="phoneFieldBlur('fssPhone')"
                   (keyup)="phoneFieldKeyUp($event, 'fssPhone', fssPhone)"
                   [(ngModel)]="airport.fssPhone">
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="edit-operations">
            <mat-select placeholder="Wind Indicator" [(value)]="selectedWindIndicator" name="windIndicator" formControlName="windIndicator">
              <mat-option value="Yes">Yes</mat-option>
              <mat-option value="No">No</mat-option>
              <mat-option value="Lighted">Lighted</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="edit-operations">
            <input matInput
                   placeholder="Mag Var"
                   formControlName="magVariation"
                   [(ngModel)]="airport.magVariation">
          </mat-form-field>
          <mat-form-field class="edit-operations">
            <input matInput
                   placeholder="Mag Var Epoch Year"
                   formControlName="magVariationEpochYear"
                   [(ngModel)]="airport.magVariationEpochYear">
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="edit-operations">
            <mat-select placeholder="Segmented Circle" [(value)]="selectedSegmentedCircle" name="segmentedCircle" formControlName="segmentedCircle">
              <mat-option value="Yes">Yes</mat-option>
              <mat-option value="No">No</mat-option>
              <mat-option value="Lighted">Lighted</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="edit-operations">
            <mat-select placeholder="Beacon" [(value)]="selectedBeacon" name="beacon" formControlName="beacon">
              <mat-option value="Yes">Yes</mat-option>
              <mat-option value="No">No</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="edit-operations">
            <input matInput
                   placeholder="Beacon Color"
                   formControlName="beaconColor"
                   [(ngModel)]="airport.beaconColor">
          </mat-form-field>
        </p>
      </fieldset>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="mat-raised-button submit-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
